import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//	icon library and icons
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBook,
    faBookOpen,
    faArchive,
    faBug,
    faCheckCircle,
    faChevronDown,
    faCog,
    faEye,
    faEyeSlash,
    faExclamationCircle,
    faHome,
    faInfoCircle,
    faTimes
} from '@fortawesome/free-solid-svg-icons';

import { init } from 'state/account/account.reducer';

import { accountStateSelector, authTokenSelector } from 'state/account/account.selectors';
import store from 'state/store';

import { setLoggedOutInterceptor } from 'util/axiosClient';

import Navigation from 'components/navigation/navigation.component';
import Footer from 'components/footer/footer.component';

import './style.css';

const App = (props) => {
    const { children } = props;

    const dispatch = useDispatch();

    const { token } = useSelector(authTokenSelector);
    const { initComplete } = useSelector(accountStateSelector);

    library.add([
        faArchive,
        faBug,
        faBook,
        faBookOpen,
        faCheckCircle,
        faChevronDown,
        faCog,
        faEye,
        faEyeSlash,
        faExclamationCircle,
        faHome,
        faInfoCircle,
        faTimes
    ]);

    setLoggedOutInterceptor(store);

    useEffect(() => {
        dispatch(init());
    }, []);

    return (
        <div className="app">
            <Navigation token={token} />
            {initComplete && children}
            <Footer />
        </div>
    );
};

export default App;
